<div class="form-group mb-3" [formGroup]="parentForm()">
  <div class="text-box">
    @if (label()) {
      <label [for]="id()" [class]="labelClass()" class="form-label">{{
        label()
      }}</label>
    }
    <div [class.input-group]="clearButton() || !!buttonText()">
      <input
        [id]="id()"
        [type]="type()"
        class="form-control"
        [formControlName]="formControlProp() ?? null"
        [placeholder]="placeholder() || ''"
        [class.is-invalid]="invalid()"
      />

      @if (
        clearButton() &&
        formControlProp() != null &&
        parentForm().controls[formControlProp()!].value
      ) {
        <button
          type="button"
          class="btn bg-transparent clear"
          (click)="clear()"
        >
          <i class="fal fa-times-circle"></i>
        </button>
      }

      @if (buttonText()) {
        <button
          class="btn btn-primary"
          type="button"
          [disabled]="buttonDisabled() || loading()"
          (click)="buttonClick()"
        >
          @if (loading()) {
            <i class="fal fa-sync fa-spin ms-0"></i>
          }
          @if (!loading()) {
            {{ buttonText() }}
          }
        </button>
      }
    </div>
    <ng-content select="[typeahead-list]"></ng-content>
  </div>
  <div class="content mt-1">
    <ng-content></ng-content>
  </div>
</div>
